<template>
  <card-renderless v-slot="{ htmlContent }">
    <div
      class="relative flex flex-col w-full h-full bg-white bg-center bg-no-repeat bg-cover rounded shadow-md select-none swiper-lazy"
    >
      <div class="flex items-center justify-center flex-grow w-full max-h-full p-4">
        <div
          class="t3m-Card-text"
          v-html="htmlContent"
        ></div>
      </div>
    </div>
  </card-renderless>
</template>

<script>
import CardRenderless from "@/components/Card/CardRenderless";
export default {
  components: {
    CardRenderless,
  },
};
</script>
